import React, { useState, useEffect, memo } from 'react';
import { useSelector } from 'react-redux';

import TripSpeedEventPopup from '../TrackTrace/TripSpeedEventPopupHM';
import { getSpeedEventsFiltersColors } from '../../../component/helpers/helperTripsGrid';

const TripSpeedEvents = (props) => {
	const { device_id, map, mapUI } = props;
	const tripsSpeedEvents = useSelector(state => state.dashboardData.tripsSpeedEvents);
	const tripsSpeedEventsFilters = useSelector(state => state.dashboardData.tripsSpeedEventsFilters);

	const [showSpeedEventPopup, setShowSpeedEventPopup] = useState(false);
	const [hoveredEvent, setHoveredEvent] = useState(null);
	const [hoveredLatLng, setHoveredLatLng] = useState(null);
	const [speedEventPolylines, setSpeedEventPolylines] = useState([]);

	useEffect(() => {
		if (!map || !tripsSpeedEvents.length) return;

		speedEventPolylines.forEach(poly => {
			if (map.getObjects().includes(poly)) {
				map.removeObject(poly);
			}
		});

		const newPolylines = tripsSpeedEvents.map((item) => {
			if (tripsSpeedEventsFilters[item.event_type] && Array.isArray(item.positions) && item.positions.length > 1) {
				const polylineOptions = {
					strokeColor: getSpeedEventsFiltersColors[item.event_type],
					lineWidth: 6,
					zIndex: 1000,
				};

				const dashedPolylineOptions = {
					strokeColor: 'rgba(255, 255, 255, 0.5)',
					lineWidth: 3,
					lineDash: [1, 7],
					lineHeadCap: 'arrow-head',
					lineTailCap: 'arrow-tail',
				};

				const lineString = new H.geo.LineString();
				item.positions.forEach(pos => lineString.pushPoint({ lat: pos.lat, lng: pos.lng }));

				const polyline = new H.map.Polyline(lineString, { style: polylineOptions });
				const dashedPolyline = new H.map.Polyline(lineString, { style: dashedPolylineOptions });

				polyline.addEventListener('pointerenter', (e) => handleMouseOver(e, item), true);
				polyline.addEventListener('pointermove', (e) => handleMouseOver(e, item), true);

				map.addObject(polyline);
				map.addObject(dashedPolyline);

				return polyline;
			}
			return null;
		}).filter(poly => poly !== null);

		setSpeedEventPolylines(newPolylines);

		return () => {
			newPolylines.forEach(polyline => {
				if (map.getObjects().includes(polyline)) {
					map.removeObject(polyline);
					polyline.removeEventListener("pointerenter", (e) => handleMouseOver(e), true);
					polyline.removeEventListener("pointermove", (e) => handleMouseOver(e), true);
				}
			});
		};
	}, [map, tripsSpeedEvents, tripsSpeedEventsFilters]);

	const handleMouseOver = (e, speedEvent) => {
		const position = map.screenToGeo(e.currentPointer.viewportX, e.currentPointer.viewportY);
		setHoveredEvent(speedEvent);
		setHoveredLatLng(position);
		setShowSpeedEventPopup(true);
	}

	return (
		<div>
			{showSpeedEventPopup && (
				<TripSpeedEventPopup
					event={hoveredEvent}
					device_id={device_id}
					position={hoveredLatLng}
					mapUI={mapUI}
					setShowSpeedEventPopup={setShowSpeedEventPopup}
				/>
			)}
		</div>
	)
};

export default memo(TripSpeedEvents);
